/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Start_TrialInputs */

const en_b2b_start_trial = /** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialize Your Enterprise Hub`)
};

const es_b2b_start_trial = /** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializar Hub Empresarial`)
};

const fr_b2b_start_trial = /** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialiser votre Hub d'Entreprise`)
};

const de_b2b_start_trial = /** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deinen Enterprise-Hub initialisieren`)
};

const id_b2b_start_trial = /** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi Hub Perusahaan Anda`)
};

/** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */
const ja_b2b_start_trial = en_b2b_start_trial;

/** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */
const zh_b2b_start_trial = en_b2b_start_trial;

/** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */
const ar_b2b_start_trial = en_b2b_start_trial;

/** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */
const it_b2b_start_trial = en_b2b_start_trial;

/** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */
const ru_b2b_start_trial = en_b2b_start_trial;

/** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */
const pt_b2b_start_trial = en_b2b_start_trial;

/** @type {(inputs: B2b_Start_TrialInputs) => LocalizedString} */
const ko_b2b_start_trial = en_b2b_start_trial;

/**
* | output |
* | --- |
* | "Initialize Your Enterprise Hub" |
*
* @param {B2b_Start_TrialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_start_trial = /** @type {((inputs?: B2b_Start_TrialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Start_TrialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_start_trial(inputs)
	if (locale === "es") return es_b2b_start_trial(inputs)
	if (locale === "fr") return fr_b2b_start_trial(inputs)
	if (locale === "de") return de_b2b_start_trial(inputs)
	if (locale === "ja") return ja_b2b_start_trial(inputs)
	if (locale === "zh") return zh_b2b_start_trial(inputs)
	if (locale === "ar") return ar_b2b_start_trial(inputs)
	if (locale === "id") return id_b2b_start_trial(inputs)
	if (locale === "it") return it_b2b_start_trial(inputs)
	if (locale === "ru") return ru_b2b_start_trial(inputs)
	if (locale === "pt") return pt_b2b_start_trial(inputs)
	return ko_b2b_start_trial(inputs)
});